import { Box, styled } from "@mui/material";
import { tokens } from "../../theme";
import useMediaQuery from "@mui/material/useMediaQuery";

export const DataGridTopHeader = styled(Box)(({ theme }) => {
  const colors = tokens(theme.palette.mode);

  return {
    height: "75vh",
    "& .MuiDataGrid-root": {
      border: "none",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "none",
    },
    "& .name-column--cell": {
      color: colors.greenAccent[300],
    },
    "& .MuiDataGrid-container--top [role=row]": {
      backgroundColor: `${colors.blueAccent[700]} !important`,
      borderBottom: "none",
    },
    "& .MuiDataGrid-virtualScroller": {
      backgroundColor: colors.primary[400],
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: "none",
      backgroundColor: colors.blueAccent[700],
    },
    "& .MuiCheckbox-root": {
      color: `${colors.greenAccent[200]} !important`,
    },
    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
      color: `${colors.grey[100]} !important`,
    },
  };
});

export const SidebarContainer = styled(Box)(({ theme }) => {
  const colors = tokens(theme.palette.mode);

  return {
    "& .pro-sidebar-inner": {
      background: `${colors.primary[400]} !important`,
    },
    "& .pro-icon-wrapper": {
      backgroundColor: "transparent !important",
    },
    "& .pro-inner-item": {
      padding: "5px 35px 5px 20px !important",
    },
    "& .pro-inner-item:hover": {
      color: "#868dfb !important",
    },
    "& .pro-menu-item.active": {
      color: "#6870fa !important",
    },
  };
});

export const FormContainer = styled(Box)(({ theme }) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");

  return {
    display: "grid",
    gap: "30px",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
  };
});
